import { StudyContextData, SubmissionContextData } from "@/context/AppContext";

import { SubmissionForm } from "@/views/study/components/submission/SubmissionForm";
import { submissionFormValid } from "@/views/study/components/submission/submissionFormValid";

import { DropZone } from "@/components/submission/DropZone";

interface IdleFlowProps {
  studyContext: StudyContextData;
  submissionContext: SubmissionContextData;
}

export function IdleFlow({ studyContext, submissionContext }: IdleFlowProps) {
  const { onReadFile, onReadFileError } = submissionContext;
  const valid = submissionFormValid(submissionContext);
  return (
    <SubmissionForm submissionContext={submissionContext} studyContext={studyContext}>
      <DropZone onReadFile={onReadFile} onReadFileError={onReadFileError} disabled={!valid} />
    </SubmissionForm>
  );
}
